import ViewPurchaseInvoice from "../../../../components/@documents/purchase_invoices/ViewPurchaseInvoice";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function PurchaseInvoiceViewPage() {

    return (
        <ViewPurchaseInvoice 
            routeType={routeTypes.admin}
        />
    )
}